import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAddDocument$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAddDocument extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-add-document", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.20837 1.54175C4.10374 1.54175 3.20837 2.43712 3.20837 3.54175V16.4584C3.20837 17.563 4.10374 18.4584 5.20837 18.4584H14.7917C15.8963 18.4584 16.7917 17.563 16.7917 16.4584V7.70841C16.7917 7.58938 16.764 7.47683 16.7146 7.37686C16.6894 7.32559 16.6579 7.27661 16.6202 7.23104C16.6036 7.21094 16.586 7.19173 16.5674 7.17347L11.16 1.76607C11.0948 1.69977 11.0174 1.64553 10.9315 1.607C10.8379 1.56507 10.7342 1.54175 10.625 1.54175H10.625H5.20837ZM11.375 4.10245V6.45841C11.375 6.73462 11.5988 6.95841 11.875 6.95841H14.231L11.375 4.10245ZM4.70837 3.54175C4.70837 3.26554 4.93217 3.04175 5.20837 3.04175H9.87504V6.45841C9.87504 7.56305 10.7704 8.45841 11.875 8.45841H15.2917V16.4584C15.2917 16.7346 15.0679 16.9584 14.7917 16.9584H5.20837C4.93217 16.9584 4.70837 16.7346 4.70837 16.4584V3.54175ZM10 9.875C10.4142 9.875 10.75 10.2108 10.75 10.625V11.9583H12.0833C12.4975 11.9583 12.8333 12.294 12.8333 12.7083C12.8333 13.1225 12.4975 13.4583 12.0833 13.4583H10.75V14.7917C10.75 15.2059 10.4142 15.5417 10 15.5417C9.58579 15.5417 9.25 15.2059 9.25 14.7917V13.4583H7.91663C7.50241 13.4583 7.16663 13.1225 7.16663 12.7083C7.16663 12.294 7.50241 11.9583 7.91663 11.9583H9.25V10.625C9.25 10.2108 9.58579 9.875 10 9.875Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-add-document-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-add-document", "wpp-icon-add-document-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-add-document-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-add-document-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAddDocument$1);
      }
      break;
  } });
}

const WppIconAddDocument = WppIconAddDocument$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAddDocument, defineCustomElement };
